<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ویرایش نوع فعالیت </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <div class="card card-style overflow-visible">
                <div class="content mb-0">

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : otherWorkTypeModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="otherWorkTypeModel.title" @input="v$.otherWorkTypeModel.title.$touch()" :class="{invalid:v$.otherWorkTypeModel.title.$error}">
                        <p class="text-danger" v-if="v$.otherWorkTypeModel.title.required.$invalid && v$.otherWorkTypeModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>

                    <div class="mb-3" >
                        <v-select v-if="OrgJobList!=[]" dir="rtl" label="title" placeholder="پست سازمانی مرتبط" :filterable="false" :searchable="false" multiple chips :options="OrgJobList" :reduce="x=>x.orgJobId" v-model="otherWorkTypeModel.OrgJobIdList">
                            <template slot="option"  >
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                        <p class="text-danger" v-if="v$.otherWorkTypeModel.OrgJobIdList.requiredIfFuctionOrgJob.$invalid && v$.otherWorkTypeModel.OrgJobIdList.$dirty">لطفا پست سازمانی مرتبط را وارد کنید.</p>
                    </div>

                    <button :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateOtherWorkType">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
            </div>
        </transition>
    </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
    import {
        required,requiredIf
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';

    export default {
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                otherWorkTypeModel: {
                    code: "",
                    title: null,
                    otherWorkTypeId: 0,
                    userId: 0,
                    strOrgJobId: "",
                    OrgJobIdList:[]
                },
            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            OrgJobList() {
                return this.$store.getters.GetOrgJobList;
            },
        },
        mounted() {
            this.GetOrgJobList();
            this.GetOtherWorkTypeItem();
           
        },
        methods: {
            GetOrgJobList() {
                this.$store.dispatch("GetOrgJobListFromServer");
            },
            GetOtherWorkTypeItem() {
                this.$http.get("OtherWork/GetOtherWorkTypeItem?id=" + this.$route.params.otherWorkTypeId)
                   .then(data => {
                        this.otherWorkTypeModel = data.data;
                       
                         if (data.data.strOrgJobId != null && data.data.strOrgJobId != "") {
                            this.otherWorkTypeModel.OrgJobIdList = [];
                            this.otherWorkTypeModel.OrgJobIdList = data.data.strOrgJobId.split(',');
                            this.otherWorkTypeModel.OrgJobIdList = this.otherWorkTypeModel.OrgJobIdList.map(x => parseInt(x));
                        }
                      
                        
                    });
            },
            CreateOtherWorkType() {
                this.v$.$touch();
                if (!this.v$.$invalid) { 
                    this.otherWorkTypeModel.strOrgJobId = this.otherWorkTypeModel.OrgJobIdList.toString();
                    this.$store.dispatch("CreateOtherWorkType", this.otherWorkTypeModel);
                }
            },
           
        },
        validations: {
            otherWorkTypeModel: {
                title: {
                    required
                },
                OrgJobIdList: {
                   requiredIfFuctionOrgJob: requiredIf(function () {
                      return this.isMinVersion == true;
                    }),
                }
               
            }


        },
       
    };
</script>
